import React, { useEffect, useState } from "react";
import callImg from "../../Assets/call.svg";
import LoctionImg from "../../Assets/loction.svg";
import userprofile from "../../Assets/user.svg";
import GrowIcons from "../../Assets/grow.svg";
import Companyimg from "../../Assets/company.svg";
import GlobalImg from "../../Assets/Globe.svg";
import { Link, useNavigate } from "react-router-dom/dist";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SpeedIcon from "@mui/icons-material/Speed";
import { APIDataUrl, APITokenUrl } from "../../Utils/Utils";
import IndustryImage from "../../Assets/office-building.png";
import linkedin from "../../Assets/linkedin1.png";
import redtrendindicator from "../../Assets/redtrendindicator.svg";
import greentrendindicator from "../../Assets/greentrendindicator.svg";
import axios from "axios";
import visitLinkImage from "../../Assets/visit-link.svg";
import { Box, Tab, Tabs } from "@mui/material";
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ProspectOrganization = ({
  organizationData,
  // setLoading,
  // value,
  // setValue,
  isDownloading,
  
}) => {
  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };
  const navigate = useNavigate();
  const [showIndicator, setShowIndicator] = useState(false);
  const [industryLogo, setIndustryLogo] = useState("");
  useEffect(() => {
    if (!organizationData?.updated_at) return;
    const currentDate = new Date();
    const updatedDate = new Date(organizationData.updated_at);
    // Check if the updated date is within the last 30 days
    const diffInDays = (currentDate - updatedDate) / (1000 * 60 * 60 * 24);
    setShowIndicator(diffInDays <= 30);
  }, [organizationData?.updated_at]);
  // const getIndustryLogo = () => {
  //   const option = {
  //     method: "GET",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       "X-API-Key": APITokenUrl(),
  //     },
  //     url: `${APIDataUrl()}/v1/get_company_logo_url?org_id=${
  //       organizationData?.org_id
  //     }`,
  //   };
  //   axios(option)
  //     .then((response) => {
  //       setIndustryLogo(response?.data?.data?.company_logo_url);
  //     })
  //     .catch(() => {});
  // };
  const toDataURL = async (url) => {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  const getIndustryLogo = async () => {
    try {
      const option = {
        method: "GET",
        headers: {
          "X-API-Key": APITokenUrl(),
        },
        url: `${APIDataUrl()}/v1/get_company_logo_url?org_id=${organizationData?.org_id}`,
      };

      const response = await axios(option);
      const logoUrl = response?.data?.data?.company_logo_url;

      if (logoUrl) {
        const base64Logo = await toDataURL(logoUrl);
        setIndustryLogo(base64Logo);
      }
    } catch (error) {
      setIndustryLogo(IndustryImage);
    }
  };

  useEffect(() => {
    if (organizationData?.org_id) {
      getIndustryLogo();
    }
  }, [organizationData?.org_id]);
  const clickHandler = (event) => {
    navigate(`/companyprofilescreen/${event}/0`);
  };
  return (
    <>
      <Box className="company-profile-main-tabs-data" sx={{ width: "100%" }}>
        <section className="">
          <div
            className={
              isDownloading
                ? "cp_inner_container_leads-pdf"
                : "cp_inner_container_leads"
            }
          >
            <section className="">
              <div className=" CompanyProfile-outter-container">
                <div className="CompanyProfile-flex-container">
                  <div className="CompanyProfile-flex-outter-container">
                    <div className="CompanyProfile-img">
                      <img
                        src={industryLogo ? industryLogo : IndustryImage}
                        style={{ width: "100%", height: "100%" }}
                        onError={(e) => (e.target.src = IndustryImage)}
                        crossOrigin="anonymous"
                      />
                    </div>
                    <div>
                      <h3
                        className="Netflix-heading"
                        style={{ cursor: "pointer" }}
                        onClick={() => clickHandler(organizationData?.org_id)}
                      >
                        {organizationData?.name ? organizationData?.name : "-"}
                      </h3>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={GlobalImg}
                          alt=""
                        />
                        {organizationData?.website_url ? (
                          <Link
                            to={organizationData?.website_url}
                            target="_blank"
                            className="clickable-link-for-website"
                          >
                            <p>
                              {organizationData?.website_url?.split("www.")?.[1]
                                ? organizationData?.website_url?.split(
                                    "www.",
                                  )?.[1]
                                : organizationData?.website_url?.split(
                                      "http://",
                                    )?.[1]
                                  ? organizationData?.website_url?.split(
                                      "http://",
                                    )?.[1]
                                  : organizationData?.website_url?.split(
                                        "https://",
                                      )?.[1]
                                    ? organizationData?.website_url?.split(
                                        "https://",
                                      )?.[1]
                                    : organizationData?.website_url}
                            </p>
                          </Link>
                        ) : (
                          <p>Not Available</p>
                        )}
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={callImg}
                          alt=""
                        />
                        <p>
                          {organizationData?.phone_number
                            ? organizationData?.phone_number
                            : "Not Available"}
                        </p>
                      </div>
                      <div className="company-profile-mention-main">
                        <div className="company-profile-mention-b1">
                          <img
                            src={linkedin}
                            alt=""
                            style={{ width: "17px", height: "17px" }}
                          />
                          {organizationData?.linkedin
                            ? organizationData.linkedin.split(".com/")?.[1]
                            : "-"}
                        </div>
                        <div>
                          <a href={organizationData?.linkedin} target="_blank">
                            <img
                              src={visitLinkImage}
                              alt=""
                              style={{ width: "17px", height: "15px" }}
                            />
                          </a>
                        </div>
                      </div>
                      <div className="CompanyProfile-content">
                        <img
                          className="CompanyProfile-icons"
                          src={LoctionImg}
                          alt=""
                        />
                        <p>{`${
                          organizationData?.street
                            ? organizationData?.street + `,`
                            : organizationData?.street === null
                              ? ""
                              : organizationData?.street
                        } ${
                          organizationData?.location_identifiers
                            ? organizationData?.location_identifiers + `,`
                            : organizationData?.location_identifiers === null
                              ? ""
                              : organizationData?.location_identifiers
                        } ${
                          organizationData?.postalcode
                            ? organizationData?.postalcode + `,`
                            : organizationData?.postalcode === null
                              ? ""
                              : organizationData?.postalcode
                        } ${
                          organizationData?.country
                            ? organizationData?.country
                            : organizationData?.country === null
                              ? ""
                              : organizationData?.country
                        }`}</p>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      "CompanyProfile-cont-rightside"
                    }
                  >
                    <div className="CompanyProfile-content">
                      <SpeedIcon className="CompanyProfile-icons ai-score-icon" />
                      <p>
                        Orbit Score -
                        {organizationData?.ai_score !== null &&
                        organizationData?.ai_score !== undefined
                          ? organizationData?.ai_score
                          : "NA"}
                      </p>
                    </div>
                    <div className="CompanyProfile-content">
                      <img
                        className="CompanyProfile-icons"
                        src={userprofile}
                        alt=""
                      />
                      <p>
                        Employees-
                        {organizationData?.num_employees
                          ? organizationData?.num_employees
                          : "Not Available"}
                        {showIndicator &&
                          organizationData?.num_employees_movement !== 0 && (
                            <img
                              style={{
                                paddingLeft: "10px",
                                width: "18px",
                                height: "13px",
                              }}
                              src={
                                organizationData?.num_employees_movement >
                                organizationData?.num_employees
                                  ? greentrendindicator
                                  : redtrendindicator
                              }
                              alt="Trend Indicator"
                            />
                          )}{" "}
                      </p>
                    </div>
                    <div className="CompanyProfile-content">
                      <img
                        className="CompanyProfile-icons"
                        src={GrowIcons}
                        alt=""
                      />
                      <p>
                        Annual revenue -
                        {organizationData?.revenue_range
                          ? organizationData?.revenue_range
                          : "Not Available"}
                        {showIndicator &&
                          organizationData?.revenue_range_movement !== 0 && (
                            <img
                              style={{
                                paddingLeft: "10px",
                                width: "18px",
                                height: "13px",
                              }}
                              src={
                                organizationData?.revenue_range_movement >
                                organizationData?.revenue_range
                                  ? greentrendindicator
                                  : redtrendindicator
                              }
                              alt="Revenue Trend Indicator"
                            />
                          )}
                      </p>
                    </div>
                    <div className="CompanyProfile-content">
                      <img
                        className="CompanyProfile-icons"
                        src={Companyimg}
                        alt=""
                      />
                      <p className="industry-mentions">
                        Industry/ Sector -{" "}
                        {organizationData?.categories
                          ?.split(/(?<=,)|\s+/) // Split by spaces while keeping commas intact
                          .map(
                            (word) =>
                              word.charAt(0).toUpperCase() +
                              word.slice(1).toLowerCase(),
                          )
                          .join(" ")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="CompanyProfile-infomation-main">
                  <div>
                    <Accordion defaultExpanded>
                      <AccordionSummary
                        expandIcon={<KeyboardArrowDownIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                      >
                        <Typography className="company_bio_trio">
                          Organization Bio
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography className="CompanyProfile-infomation">
                          <p className="industry-mentions">
                            {organizationData?.description
                              ? organizationData.description.replace(
                                  /(^|\.\s+)([a-z])/g,
                                  (match) => match.toUpperCase(),
                                )
                              : "Not Available"}
                          </p>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
            </section>
            {/* {isDownloading ? null : (
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  className="Companydata"
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="News/Events " {...a11yProps(0)} />
                  <Tab label="AI Path" {...a11yProps(1)} />
                </Tabs>
              </Box>
            )} */}
          </div>
        </section>
      </Box>
    </>
  );
};
export default ProspectOrganization;
